export const languages = {
    en: { nativeName: "English" },
    sv: { nativeName: "Svenska" },
};
